import React, { useState,useEffect } from 'react';
import '../Assets/Css/contact.css';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaGlobe } from 'react-icons/fa';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { BASE_URL } from '../BaseURL';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';

export default function Contact() {
  useEffect(() => {
      AOS.init({ duration: 1000 });
    }, []);
 
    const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        userName: formData.name,
        mobile: formData.mobile,
        email: formData.email,
        message: formData.message
      };

      const response = await axios.post(`${BASE_URL}/enquiry/sendContactEnquiry`, payload);

      toast.success(response.data.message || 'Message sent successfully');
      setFormData({ name: '', mobile: '', email: '', message: '' });
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to send message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mainnav min-vh-100">

      <Helmet>
        <title>Contact Us | Samashree Enterprises</title>
        <meta name="description" content="Get in touch with Samashree Enterprises for road marking, civil construction, and maintenance services. We're here to serve you in Nashik and beyond." />
        <meta name="keywords" content="Samashree Enterprises, Contact Samashree, Road Marking Services, Civil Construction, Maintenance Services, Nashik, Maharashtra" />
        <meta name="author" content="Samashree Enterprises Pvt. Ltd." />
        <link rel="canonical" href="https://www.samashreeenterprises.com/contact" />
      </Helmet>

      <Toaster/>

      {/* Hero Section */}
      <section className="hero-section7">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in">Contact Us</h1>
          <p data-aos="zoom-in" data-aos-delay="100">We are committed to your service</p>
          <a href="#contact-details" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100">Get in Touch</a>
        </div>
      </section>

      {/* Contact Details */}
      <section id="contact-details" className="py-5 contact-section">
        <Container>
          <Row className="mb-4">
  <Col md={12} className="text-center" data-aos="zoom-in" data-aos-delay="100">
    <h2>
      <span style={{ color: '#FE8200',letterSpacing:'2px', fontWeight: 'bolder' }}>SAMASHREE</span>{' '}
      <span style={{ color: '#008080',letterSpacing:'2px', fontWeight: 'bold' }}>ENTERPRISES </span>
    </h2>
 <p style={{ color: '#28326E', fontWeight: 'bold', fontFamily: 'Pacifico, cursive' }}>
  Committed @ Your Service
</p>
  </Col>
</Row>

       <Row className="p-2 h-100 align-items-stretch">
  {/* Contact Info Card */}
  <Col md={6} className="mb-4 d-flex  h-100">
    <div className=" shadow rounded bg-white w-100 h-100" style={{padding:'45px'}}>
      <h5 className="mb-3">
        <FaMapMarkerAlt className="me-2" style={{ color: '#FE8200' }} />
        Address
      </h5>
      <p>
        Flat No. 05, Aksharpushp Apartment,<br />
        Kevadiban, Panchvati, Nashik 422003,<br />
        Maharashtra, India
      </p>

      <h5 className="mt-4">
        <FaPhoneAlt className="me-2" style={{ color: '#FE8200' }} />
        Phone
      </h5>
      <p>+91 74105 96426<br />+91 63625 14335</p>

      <h5 className="mt-4">
        <FaEnvelope className="me-2" style={{ color: '#FE8200' }} />
        Email
      </h5>
      <p>info@samashreeenterprises.com</p>

      <h5 className="mt-4">
        <FaGlobe className="me-2" style={{ color: '#FE8200' }} />
        Website
      </h5>
      <p className=''>
        <a href="https://samashreeenterprises.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark">
          www.samashreeenterprises.com
        </a>
      </p>
    </div>
  </Col>

  {/* Contact Form Card */}
  <Col md={6} className="d-flex h-100">
        <div className="p-4 shadow rounded bg-white w-100 h-100">
          <h4 className="mb-3 text-center" style={{ color: '#FE8200' }}>Contact Form</h4>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formName">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3" controlId="formMobile">
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Enter your mobile number"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    pattern="[0-9]{10}"
                    required
                    maxLength={10}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formMessage">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Your message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button style={{ border: 'none' }} className="btn-get" type="submit" disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" role="status" className="me-2" />
                  Sending...
                </>
              ) : (
                'Send Message'
              )}
            </Button>
          </Form>
        </div>
      </Col>
</Row>
        </Container>
      </section>
    </div>
  );
}
